webpackJsonp([15,18],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _appConfig = __webpack_require__(2);

var scheduleList = function scheduleList() {
	var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _appConfig.ARTICLE_NUMBER_PER_PAGE;
	return fetch(_appConfig.apiUri + '/schedule?from=' + from + '&take=' + count).then(function (res) {
		return res.json();
	}).catch(function (err) {
		return console.error(err);
	});
};

exports.default = scheduleList;

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

__webpack_require__(20);

__webpack_require__(18);

__webpack_require__(21);

__webpack_require__(22);

__webpack_require__(8);

__webpack_require__(55);

__webpack_require__(150);

__webpack_require__(460);

__webpack_require__(459);

__webpack_require__(15);

var _setupCommonJS = __webpack_require__(16);

var _setupCommonJS2 = _interopRequireDefault(_setupCommonJS);

var _appConfig = __webpack_require__(2);

var _wordingSetter = __webpack_require__(39);

var _wordingSetter2 = _interopRequireDefault(_wordingSetter);

var _wordingJson = __webpack_require__(38);

var _wordingJson2 = _interopRequireDefault(_wordingJson);

var _scheduleList = __webpack_require__(107);

var _scheduleList2 = _interopRequireDefault(_scheduleList);

var _generateScheduleBlock = __webpack_require__(237);

var _generateScheduleBlock2 = _interopRequireDefault(_generateScheduleBlock);

var _hideLoadingImage = __webpack_require__(14);

var _hideLoadingImage2 = _interopRequireDefault(_hideLoadingImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _setupCommonJS2.default)();

var wordingJsonPromise = (0, _wordingJson2.default)('transportation').then(function (json) {
	return (0, _wordingSetter2.default)(json);
});

var scheduleListPromise = (0, _scheduleList2.default)(0, 3).then(function (json) {
	json.schedules.forEach(function (item) {
		document.querySelector('.section-block > .content.-row.-images').appendChild((0, _generateScheduleBlock2.default)(item.id, item.title, _appConfig.uploadUri + '/' + item.thumb));
	});
});

/**
 * make sure each promise is finished
 */
Promise.all([wordingJsonPromise, scheduleListPromise]).then(function () {
	return (0, _hideLoadingImage2.default)();
});

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var generateScheduleBlock = function generateScheduleBlock(id, title, imageUrl) {
	var template = document.querySelector('._template-block > .image-block').cloneNode(true);
	template.setAttribute('href', 'schedules/' + id);
	template.setAttribute('style', 'background-image: url(' + imageUrl + ')');
	template.lastChild.innerText = title;

	return template;
};

exports.default = generateScheduleBlock;

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(4);
__webpack_require__(5);
module.exports = __webpack_require__(200);


/***/ }),

/***/ 55:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[478]);


// WEBPACK FOOTER //
// transportation.576c47c319fdb.js